import { api } from '@/lib/api-manager'
import type { PreviousEducationCourse } from '@/types/education/previous-education-course'

export async function getPreviousEducationCoursesByRequest(requestId?: string) {
  const result = await api.get(
    `v1/requests/request/${requestId}/previous-education/courses`
  )
  const data: PreviousEducationCourse[] = result.data.data
  return data
}
